import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
const WizardContext = createContext(undefined);
// 2. The <Wizard /> Provider
export function Wizard({ children, initialStep }) {
    const [activeStep, setActiveStep] = useState(initialStep || 0);
    const [stepIds, setStepIds] = useState([]);
    const registerStep = (id) => {
        setStepIds((prev) => (prev.includes(id) ? prev : [...prev, id]));
    };
    const currentIndex = typeof activeStep === 'number' ? activeStep : stepIds.indexOf(activeStep);
    const next = () => {
        if (currentIndex < stepIds.length - 1) {
            setActiveStep(stepIds[currentIndex + 1]);
        }
    };
    const previous = () => {
        if (currentIndex > 0) {
            setActiveStep(stepIds[currentIndex - 1]);
        }
    };
    const goTo = (id) => {
        if (typeof id === 'number' && id >= 0 && id < stepIds.length) {
            setActiveStep(stepIds[id]);
        }
        else if (stepIds.includes(id)) {
            setActiveStep(id);
        }
    };
    const progress = stepIds.length > 1 ? (currentIndex / (stepIds.length - 1)) * 100 : 0;
    const contextValue = { activeStep, stepIds, registerStep, next, previous, goTo, currentIndex, progress };
    return (_jsx(WizardContext.Provider, { value: contextValue, children: typeof children === 'function' ? children(contextValue) : children }));
}
// 3. The <Steps /> Wrapper
export function Steps({ children }) {
    return _jsx("div", { className: "wizard-steps-container", children: children });
}
export function Step({ id, children }) {
    const context = useContext(WizardContext);
    if (!context)
        throw new Error('<Step /> must be used within a <Wizard />');
    // Automatically registers the step in the wizard's state upon mounting.
    React.useEffect(() => {
        context.registerStep(id);
    }, [id]);
    if (context.activeStep !== id)
        return null;
    return _jsx("div", { className: "wizard-step", children: children });
}
// 5. The useWizard() Hook for Functional Components
export function useWizard() {
    const context = useContext(WizardContext);
    if (!context) {
        throw new Error('useWizard must be used within a <Wizard>');
    }
    return context;
}
